<script>
export default {
    name: 'GcepQuickGuideLink',
}
</script>
<template>
  <a
    href="https://www.clinicalgenome.org/docs/clingen-gene-curation-expert-panel-protocol/"
    target="gcep-quick-guide"
  >
    <slot>GCEP Protocol</slot>
  </a>
</template>